import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/recentBuyers';
const FIRST_DELAY = 9000;
const VISIBLE_MS = 6000;
const GAP_MS = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const show = () => {
      setVisible(true);
      timeout = window.setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      setVisible(false);
      timeout = window.setTimeout(() => {
        setIndex(prev => (prev + 1) % recentBuyers.length);
        show();
      }, GAP_MS);
    };
    timeout = window.setTimeout(show, FIRST_DELAY);
    return () => window.clearTimeout(timeout);
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <AnimatePresence data-id="element-40" data-mp="1gwuhqhodwsld">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 right-3 z-50 sm:left-5 sm:right-auto sm:w-[360px]" role="status" aria-live="polite" data-id="element-41" data-mp="164o984x5s1tn">
          <div className="flex items-start gap-3 rounded-xl border border-gold-500/30 bg-navy-900 p-3 shadow-2xl shadow-black/60" data-id="element-42" data-mp="n7n32grvbvo4">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-500/15" data-id="element-43" data-mp="iaekwg6pzrmv">
              <CheckCircle2Icon className="h-5 w-5 text-emerald-400" aria-hidden="true" data-id="element-44" data-mp="s6hjjc2d5852" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-45" data-mp="28jy8xrdw1bob">
              <p className="truncate text-sm font-bold text-white" data-id="element-46" data-mp="28imwl36dmvll">{buyer.name}</p>
              <p className="text-[13px] leading-snug text-slate-300" data-id="element-47" data-mp="23kldii8yawa4">
                just got the Oclusion Clinical Playbook™
              </p>
              <p className="mt-0.5 text-[11px] font-medium uppercase tracking-wide text-gold-400" data-id="element-48" data-mp="2fno139kjn9zm">
                {buyer.country} · hace {buyer.minutesAgo} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-m-1 rounded p-1 text-slate-500 transition-colors duration-150 ease-out hover:text-white" data-id="element-49" data-mp="2plu1fmqpc82d">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="1wxg1h1g1z1o6" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}